import "../../../App.css";
import "../../Transaction/Transactions.css";
import SalaryAdvancePage from "../../../v2/pages/SalaryAdvancePage";

// Refactoring this, will transfer the components of this module into src/v2

function SalaryAdvance({ user, userAccess, isHideSideMenu }) {

  return (
    <SalaryAdvancePage user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu}/>
  );
}

export default SalaryAdvance;